import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { Card, CardBody, Row } from 'reactstrap';
import { TextInput } from '../../lib/components/textInput';
import { TextInputPassword } from '../../lib/components/textInputPassword';
import Footer from "../../lib/components/footer/Footer";
import { SizeMe } from 'react-sizeme';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domain, S } from '../../routes/routes'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Object Json */
import { safeDeepGetWithType } from 'iotera-base/json';

import './style.scss';
import { IoteraForm } from '../../lib/components/form';

const REGIS = "REG";
const WKEY = "TENANT_REG";
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

const schema = {
  type: "object",
  required: ["username", "first", "email", "pass", "passv", "tenant_name"],
  properties: {
    username: { type: "string", minLength: 4 },
    first: { type: "string" },
    last: { type: "string" },
    email: { type: "string", minLength: 4 },
    pass: { type: "string" },
    passv: { type: "string" },
    tenant_name: { type: "string", minLength: 4 },
  }
};

const uiSchema = {
  tenant_name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="tenant_name"
          type="text"
          label="Nama Tenant"
          placeholder="PT. IOTERA"
          textTooltip="Masukkan nama perusahaan"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  username: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="username"
          type="text"
          label="Username"
          placeholder="Username"
          textTooltip="Masukkan username untuk login"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  first: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="first"
          type="text"
          label="Nama Depan"
          placeholder="Nama Depan"
          textTooltip="Masukkan nama depan"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  last: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="last"
          type="text"
          label="Nama Belakang"
          placeholder="Nama Belakang"
          textTooltip="Masukkan nama belakang"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  email: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="email"
          type="text"
          label="Alamat Email"
          placeholder="Email"
          textTooltip="Masukkan alamat email"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  pass: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="pass"
          type="text"
          label="Password"
          placeholder="********"
          textTooltip="Masukkan password"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  passv: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="passv"
          type="text"
          label="Konfirmasi Password"
          placeholder="********"
          textTooltip="Ketik ulang password diatas untuk konfirmasi."
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
};

function Tpl(props) {
  const { id, label, required, children, displayLabel, errors } = props;
  let className = "";
  if (id === 'root_colorMasks' || id === 'root' || id === 'root_colorMask') {
    className = 'myfield';
  }
  if (displayLabel === true) {
    return (
      <div className={className} style={{ marginBottom: '10px' }}>
        <label htmlFor={id}><b>{label}{required ? "*" : null}</b></label>
        {children}
        {errors}
      </div>
    );
  } else {
    return (
      <div className={className} style={{ marginBottom: '10px' }}>
        {children}
        {errors}
      </div>
    );
  }
}

class TenantRegis extends Component {
  constructor(props) {
    super(props);
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.state = {
      file: 'https://i.imgur.com/8FWamdx.jpg',
      activeTab: '1',
      custom: window.innerWidth <= 574 ? "col-sm-6" : "col-sm-4",
      loading: false,
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      formData: {},
      padForm,
      widthImage,
      paddingStyle
    };
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.onRemovePicture = this.onRemovePicture.bind(this);
    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _domain = domain(_props);
    _props.wSetConfig({
      single_config: {
        [REGIS]: {
          wparam: {
            domain: _domain,
            usingAuth: false,
            method: "POST",
            path: "/service/web/tenant/account/auth/register",
            timeout: 180000
          },
          wcallback: {
            finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('.' + S + 'login')
                  _props.showSingleNotification({ message: 'Registrasi Sukses', level: 'success' });
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -3) {
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Password dan konfirmasi password harus sama!', level: 'error' });
                  return;
                } else if (responseResult === -4) {
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Username sudah terpakai!', level: 'error' });
                  return;
                } else if (responseResult === -5) {
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Email sudah terpakai!', level: 'error' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Registrasi Gagal', position: 'tr', level: 'error' });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  componentWillUnmount() {
    this.props.wUnsetConfig({ key: WKEY });
  }

  resize(event) {
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.setState({
      custom: window.innerWidth <= 574 ? "col-sm-6" : "col-sm-4",
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      padForm,
      widthImage,
      paddingStyle
    })
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    let submitData = event['formData'];
    const username = submitData['username'];
    const email = submitData['email'];
    const pass = submitData['pass'];
    const passv = submitData['passv'];
    const first = submitData['first'];
    const last = submitData['last'];
    const tenant_name = submitData['tenant_name'];
    _this.setState({
      formData: submitData,
      loading: true
    })
    _props.wSingleRequestCall({
      id: REGIS,
      body: {
        username,
        email,
        pass,
        passv,
        first,
        last,
        tenant_name,
        email_verification: false
      }
    });
  }

  handleBack() {
    this.props.history.push('.' + S + 'login')
  };

  handleChange(event) {
    if (event.target.files.length > 0) {
      this.setState({
        file: URL.createObjectURL(event.target.files[0])
      })
    }
  }

  onRemovePicture() {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus gambar ini?',
      'Ya, hapus',
      () => this.setState({
        file: 'https://i.imgur.com/8FWamdx.jpg'
      }),
      null,
      null
    )
  }

  render() {
    const _this = this
    const _state = _this.state
    window.onresize = _this.resize;
    const { loading, paddingStyle, formData, padForm, widthImage, file } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let dataToShow = {};
    if (formData === {}) {
      dataToShow = {}
    } else {
      dataToShow = formData;
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <div className="view-content view-pages view-session d-flex justify-content-center align-items-center flex-column"
            style={{ padding: 0 }} >
            <Card className="mb-3 form-card" style={{ minWidth: '80%', maxWidth: '80%', marginTop: '4%' }}>
              <CardBody style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: padForm, paddingTop: padForm }}>
                <Row style={{ margin: 0 }}>
                  <div className="col-md-4" style={{ paddingRight: 0, paddingLeft: 0 }} >
                    <SizeMe >{({ size }) =>
                      <Card className="cobaForm" style={{
                        minWidth: widthImage, maxWidth: widthImage, height: size.width * 4 / 4,
                        maxHeight: size.width * 4 / 4, border: '5px solid white',
                        boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: '50%'
                      }}>
                        <CardBody style={{ margin: 20 }}>
                          <div className="containers" style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
                            <Card className="cardssss" style={{ backgroundColor: '#ffffff', mindWidth: '100%', minHeight: '100%' }}>
                              <CardBody >
                                <Row >
                                  <img src={file} alt="Profile" style={{
                                    minHeight: '100%', maxHeight: '100%',
                                    minWidth: '100%', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0
                                  }} />
                                </Row>
                              </CardBody>
                            </Card>
                            {file === 'https://i.imgur.com/8FWamdx.jpg' ?
                              <div className="middle">
                                <Row >
                                  <div className="col-md-12">
                                    <label className="button-iotera-primary-outline text"
                                      style={{ padding: paddingStyle, marginBottom: 0 }}>
                                      <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                      <span>Unggah</span>
                                    </label>
                                  </div>
                                </Row>
                              </div> :
                              <div className="middle">
                                <Row style={{ marginBottom: 5 }}>
                                  <div className="col-md-12">
                                    <label className="button-iotera-primary-outline text"
                                      style={{ padding: paddingStyle, marginBottom: 0 }}>
                                      <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                      <span>Ganti</span>
                                    </label>
                                  </div>
                                </Row>
                                <Row>
                                  <div className="col-md-12">
                                    <button className="button-iotera-red-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}
                                      onClick={(e) => _this.onRemovePicture()} >
                                      Hapus
                                    </button>
                                  </div>
                                </Row>
                              </div>}
                          </div>
                        </CardBody>
                      </Card>}
                    </SizeMe>
                  </div>
                  <div className="col-md-8" style={{ paddingRight: padForm, paddingLeft: padForm }} >
                    <IoteraForm
                      schema={schema}
                      uiSchema={uiSchema}
                      onSubmit={this.handleSubmit}
                      FieldTemplate={Tpl}
                      formData={dataToShow}
                    >
                      <div className="button-right" style={{ marginTop: 10 }}>
                        <button className="button-iotera-white" onClick={(e) => _this.handleBack(e)}
                          style={{ minWidth: '0%' }} type="button">Batal</button>
                        <button className="button-iotera-primary" style={{ minWidth: '0%' }} type="submit">Registrasi</button>
                      </div>
                    </IoteraForm>
                  </div>
                </Row>
              </CardBody>
            </Card>
            <Footer />
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(null, mapDispatchToProps)(withRouter(TenantRegis));
